import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer>
            <div className="footer">
                <div className="logo-small">
                    <span className="music-icon">♪</span>
                    <span className="title">VibeCheck</span>
                </div>
                <p className="copyright">© 2025 VibeCheck. All rights reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;